import { REPORTS_PATH } from 'features/report/types'
import * as moduleActions from './actions'
import reducer from './reducer'
import { effects } from './effects'
import * as types from './actions/types'

export const actions = moduleActions
export { reducer, effects, types }

export const constants = {
  PATH_ALL: `${REPORTS_PATH}/vehicle-emissions`,
  ROUTE_ALL: `${REPORTS_PATH}/vehicle-emissions`,
}

export default constants
